export const LENDER_HUB_DEAL_REDUCER_PATH = "lenderHubDealApi";

export const LENDER_HUB_DEAL_SERVICE_TAG = "LenderHubDeal";

export const LENDER_HUB_DEAL_RELATED_TAGS = [LENDER_HUB_DEAL_SERVICE_TAG];
